<script>
import { onMounted, reactive, ref } from "vue";
import { fetchNotes } from "@/use/repositories/prescriptions/fetchNotes";
import { fetchMedia } from "@/use/repositories/prescriptionTests/fetchMedia";
import Notes from "@/components/Notes.vue";
import Spinner from "@/components/general/Spinner.vue";
import SliderImage from "@/components/general/SliderImages";

export default {
  name: "NoteOverview",
  components: { Notes, Spinner, SliderImage  },
  props: {
    prescriptionTest: { type: Object, required: true },
  },
  setup(props) {
    const relativeNotes = ref([]);
    const prescriptionTestMedia = ref([]);
    const spinner = reactive({
      notes: false,
      media: false,
    });

    const getAllNotes = async () => {
      spinner.notes = true;
      try {
        const { notes } = await fetchNotes(props.prescriptionTest.prescription_id);

        relativeNotes.value = notes.prescription_tests.find(
          (item) => item.id === props.prescriptionTest.id
        );
      } catch (error) {
        console.log(error);
      } finally {
        spinner.notes = false;
      }
    };

    const getPrescriptionTestMedia = async () => {
      spinner.media = true;
      try {
        const { prescriptionTest } = await fetchMedia(props.prescriptionTest.id);
        prescriptionTestMedia.value = prescriptionTest?.media ?? [];
      } catch (error) {
        console.log(error);
      } finally {
        spinner.media = false;
      }
    };

    onMounted(() => {
      getAllNotes();
      getPrescriptionTestMedia();
    });

    return { relativeNotes, spinner, prescriptionTestMedia };
  },
};
</script>

<template>
  <div class="d-flex">
    <div class="rounded-custom bg-home-violet h-fit-content notes-list w-50 p-5 m-5 ">
      <h4 class="m-2 mb-4">Dalla clinica: </h4>
      <div v-if="typeof prescriptionTest.feedback === 'number'" class="d-flex m-2">
        <span class="fw-bold ">Esito Feedback: </span>
        <img
          class="mb-2 ms-2"
          :src="require(`@/assets/icons/${prescriptionTest.feedback ? 'like-green' : 'dislike-red'}.svg`)"
          width="25"
          alt="note-icon" />
      </div>
      <div>
        <div class="m-2">
          <span class="fw-bold">Feedback: </span>
          <span>{{ prescriptionTest.feedback_note ?? "Nessun feedback presente" }}</span>
        </div>
        <hr >
        <div class="m-2">
          <span class="fw-bold me-2">Nota:</span>
          <span>{{ prescriptionTest.notes ?? "Nessuna nota presente" }}</span>
        </div>
      </div>
      <hr>
      <div class="m-2">
        <span class="fw-bold me-2">Media:</span>
        <Spinner v-if="spinner.media" />
        <SliderImage
          v-else-if="prescriptionTestMedia.length"
          :elements="prescriptionTestMedia.map((item) => ({
            createdAt: item.created_at,
            temporaryUrl: item.url,
          }))"
          :item-to-show="prescriptionTestMedia.length"
        />
        <span v-else>Nessun media presente</span>
      </div>
    </div>
    <div class="notes-list w-50">
      <Spinner v-if="spinner.notes" />
      <Notes v-else-if="relativeNotes?.laboratory_notes?.length" :notes="[relativeNotes]" />
      <div v-else class="d-flex h-100 justify-content-center align-items-center">
        {{ $t('No notes present') }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .notes-list {
      max-height: 70vh;
      overflow-y: auto;
  }
  .h-fit-content {
      height: fit-content;
  }
</style>
